import * as React from "react";
import Box from "@mui/material/Box";
import { Button, List, ListItem, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function CallToActionDetails() {

    function handleScroll() {
        const element = document.getElementById('lets_connect');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
  return (
    <Box
      sx={{
        width: {xs:"90%",md:"80%"},
        height: "fit-content",
        textAlign: "center",
        // margin: "auto",
        margin: { xs: "2rem auto", md: "8rem auto 2rem" },
        background: "#1668D7",
        // backgroundColor: 'primary.dark',
        // background:
        //   "linear-gradient(135deg, #f4f9ff30 0%, rgba(255, 255, 255, 0) 70%), linear-gradient(45deg, #ffffff 0%, #f4f9ff30 100%)",
        // backdropFilter: "blur(20px)",
        // background: "linear-gradient(0deg, rgba(244, 249, 255, 0) 0%, #F4F9FF 100%)",

        borderRadius: "20px",
        boxShadow: "0 8px 32px 0 rgb(59 72 255 / 11%)",
      }}
    >
      <Box
        sx={{
          height: "inherit",
          width: "inherit",
          textAlign: "center",
          margin: "auto",
          // backgroundColor: "#cbe4de33",
          color: "black",
          borderRadius: "10px",
          padding: { xs: "1rem 0rem", md: "3rem 2rem" },
        }}
      >
        <Typography
          variant="h4"
          fontWeight={700}
          sx={{ color: "white" }}
          gutterBottom
        >
          Ready to propel your D2C BRAND on{" "}
          <span style={{ color: "black" }}>EPIC GROWTH?</span>
        </Typography>
        <Box mt={1} mb={3}>
          <Button
            variant="contained"
            size="large"
            onClick={handleScroll}
            sx={{
              color: "#1668D7",
              backgroundColor: "white",
              mr: 2,
              mt: "1rem",
              width: {xs:"80vw", md: "fit-content"},
              "&:hover": { color: "#1668D7", backgroundColor: "white" },
            }}
          >
            Schedule a Demo
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={handleScroll}
            sx={{
              color: "white",
              border: "1px solid white",
              mt: "1rem",
              width: {xs:"80vw", md: "fit-content"},
              "&:hover": { color: "white", border: "1px solid white" },
            }}
          >
            Start free trial
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: { sx: "flex-start", md: "center" },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
              sx={{ display: "flex", width: { xs: "70vw", md: "25vw" }, mt: 2 }}
            >
              <CheckCircleIcon sx={{ color: "white", textAlign: "initial" }} />
              <Typography sx={{ color: "white" }}>
                {" "}
                &nbsp;Start a free trial
              </Typography>
            </Box>
            <Box
              sx={{ display: "flex", width: { xs: "70vw", md: "25vw" }, mt: 2 }}
            >
              <CheckCircleIcon sx={{ color: "white", textAlign: "initial" }} />
              <Typography sx={{ color: "white" }}>
                {" "}
                &nbsp;No credit cards required
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
              sx={{ display: "flex", width: { xs: "70vw", md: "25vw" }, mt: 2 }}
            >
              <CheckCircleIcon sx={{ color: "white", textAlign: "initial" }} />
              <Typography sx={{ color: "white" }}>
                {" "}
                &nbsp;24 * 7 support available
              </Typography>
            </Box>
            <Box
              sx={{ display: "flex", width: { xs: "70vw", md: "25vw" }, mt: 2 }}
            >
              <CheckCircleIcon sx={{ color: "white" }} />
              <Typography sx={{ color: "white", textAlign: "initial" }}>
                {" "}
                &nbsp;Cancel anytime and revert back to older checkout in
                seconds!
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
